/**
 * Scroll-triggered animations using IntersectionObserver
 * Adds the `animate` class to elements with the `fade-up` or `reveal` class when they enter the viewport.
 *
 * Why: Defer animations until elements are visible for performance and UX.
 */

// Set background images from data-bg-image attribute
function initFeatureCardBackgrounds() {
  const featureCards = document.querySelectorAll('.feature-card[data-bg-image]');
  featureCards.forEach((card) => {
    const bgImage = card.getAttribute('data-bg-image');
    if (bgImage) {
      card.style.setProperty('--bg-image', `url('${bgImage}')`);
      card.style.backgroundImage = `url('${bgImage}')`;
    }
  });
}

function initScrollAnimations() {
  const animatedElements = document.querySelectorAll('.fade-up, .reveal');
  if (animatedElements.length === 0) {
    return;
  }

  // Fallback for environments without IntersectionObserver
  if (typeof window.IntersectionObserver !== 'function') {
    animatedElements.forEach((element) => element.classList.add('animate'));
    return;
  }

  const observerOptions = {
    root: null,
    // Trigger slightly before fully in view so the motion feels responsive
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.15,
  };

  const handleIntersections = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
        // Unobserve once animated to avoid repeated work
        observer.unobserve(entry.target);
      }
    });
  };

  const observer = new IntersectionObserver(handleIntersections, observerOptions);
  animatedElements.forEach((element) => {
    // Optional delay via data attribute, e.g., data-animate-delay="120" (ms)
    const delayAttr = element.getAttribute('data-animate-delay');
    if (delayAttr) {
      const delayValue = Number(delayAttr);
      element.style.transitionDelay = Number.isNaN(delayValue)
        ? delayAttr
        : `${delayValue}ms`;
    }

    // Optional duration via data attribute, e.g., data-animate-duration="700" (ms)
    const durationAttr = element.getAttribute('data-animate-duration');
    if (durationAttr) {
      const durationValue = Number(durationAttr);
      element.style.transitionDuration = Number.isNaN(durationValue)
        ? durationAttr
        : `${durationValue}ms`;
    }

    // Optional easing via data attribute, e.g., data-animate-easing="cubic-bezier(0.22,0.61,0.36,1)" or "ease-out"
    const easingAttr = element.getAttribute('data-animate-easing');
    if (easingAttr) {
      element.style.transitionTimingFunction = easingAttr;
    }

    observer.observe(element);
  });
}

// Expose to global for concatenated builds
window.initScrollAnimations = initScrollAnimations;
window.initFeatureCardBackgrounds = initFeatureCardBackgrounds;


